import { profileBG } from "utils/assets_exports/images";

import newsImg from "assets/img/news.jpg";
import { useState } from "react";
import { Input, Member, SVG } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";
import { usersArray } from "assets/data/usersData";

export type CommunityInfoProps = CustomComponentProps & {
    setShowInfo: React.Dispatch<React.SetStateAction<boolean>>;
    handleOpenMembers: (attr: "admins" | "members") => void;
};
const CommunityInfo = ({
    setShowInfo,
    handleOpenMembers
}: CommunityInfoProps) => {
    const [communityName, setCommunityName] = useState("News");
    const [communityAbout, setCommunityAbout] = useState(
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit."
    );

    //  demo -------------------
    const members = usersArray.filter((member, i) => {
        if (i % 2) {
            return member;
        }
    });
    const admins = usersArray.filter((member, i) => {
        if (i % 2 == 0) {
            return member;
        }
    });
    return (
        <div className="community-info">
            <div className="d-flex w-full flex-j-start mb-30">
                <div
                    className="d-flex flex-j-start gap-5"
                    onClick={() => setShowInfo(false)}
                >
                    <SVG svg="arrow-left" size={24} />
                    <span className="cursor-pointer">
                        Back to Community Page
                    </span>
                </div>
            </div>
            <div className="profile-header">
                <div className="cover-bg">
                    <img className="cover-image" src={profileBG} alt="" />
                    <div className="avatar">
                        <img
                            id="user-avatar"
                            className="avatar-image"
                            src={newsImg}
                            alt=""
                        />
                        <div className="avatar-button">
                            <i className="mdi mdi-camera"></i>
                        </div>
                    </div>
                    <div className="cover-overlay"></div>
                    <div
                        className="cover-edit modal-trigger"
                        data-modal="change-cover-modal"
                    >
                        <i className="mdi mdi-camera"></i>
                        <span>Edit cover image</span>
                    </div>
                    {/* <!--/html/partials/pages/profile/timeline/dropdowns/timeline-mobile-dropdown.html-->
        {{> timeline-mobile-dropdown}} */}
                </div>
            </div>
            <div className="community-info-fields card">
                {/* name */}
                <Input
                    label="Community Name"
                    value={communityName}
                    handleChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setCommunityName(e.target.value)
                    }
                    // error={nameError}
                    placeHolder="community name..."
                />
                {/* about */}
                <Input
                    label="Community About"
                    value={communityAbout}
                    handleChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setCommunityAbout(e.target.value)
                    }
                    // error={nameError}
                    placeHolder="community name..."
                />

                {/* owners */}
                <div className="field">
                    <div className="d-flex flex-j-between flex-a-center mb-20">
                        <label>Community Owners</label>
                        <a href="#" onClick={() => handleOpenMembers("admins")}>
                            view All
                        </a>
                    </div>
                    <div>
                        {admins.map((member) => (
                            <Member
                                user={member}
                                key={member.id}
                                className="mb-20"
                            />
                        ))}
                    </div>
                </div>

                {/* members */}
                <div className="field">
                    <div className="d-flex flex-j-between flex-a-center mb-20">
                        <label>Community Members</label>
                        <a
                            href="#"
                            onClick={() => handleOpenMembers("members")}
                        >
                            view All
                        </a>
                    </div>
                    <div>
                        {members.map((member) => (
                            <Member
                                user={member}
                                key={member.id}
                                className="mb-20"
                            />
                        ))}
                    </div>
                </div>

                {/* created date */}
                <Input
                    label="Created Date"
                    value="5 Days Ago"
                    handleChange={() => console.log("")}
                    // error={nameError}
                    disabled
                    className="custom-cursor-default"
                />
            </div>
        </div>
    );
};

export default CommunityInfo;
